import React, {Component} from "react";

import PagingBtn from "../../../Buttons/PagingBtn/index";
import PopupRegisterForm from "../../../Containers/PopupRegisterForm/index";
import PopupReportCard from "../../../Containers/PopupReportCard";

import * as AdminClassroomService from "../../../../services/Teacher/AdminClassroomService";
import * as AdminStudentService from "../../../../services/Teacher/AdminStudentService";
import Moment from "moment";

class AdminManagementStudent extends Component {
    state = {
        curPageStudentList: [],
        showCreatePopup: false,
        showUpdatePopup: false,
        showReportPopup: false,
        student: null,
        registerPopupActive: false,
        isUpdateMode: false,
        selectStudent: null
    }

    constructor() {
        super();

        this.curPage = 0;
        this.totalPages = 1;
        this.optionItemRange = [
            {id: 0, text: "전체 보기(1000개)", value: 1000},
            {id: 1, text: "30개씩 보기", value: 30},
            {id: 2, text: "50개씩 보기", value: 50},
        ];
        this.itemRange = 30;
        this.classrooms = ['전체 보기(학급)'];
        this.selectClassroom = '전체 보기(학급)';
        this.studentFieldInfo = [
            {id: 0, colWidth: "6%", colName: "-"},
            {id: 1, colWidth: "8%", colName: "아이디"},
            {id: 2, colWidth: "8%", colName: "이름"},
            {id: 3, colWidth: "10%", colName: "학교"},
            {id: 4, colWidth: "8%", colName: "학년"},
            {id: 5, colWidth: "15%", colName: "부모님 전화번호"},
            {id: 6, colWidth: "10%", colName: "가입일"},
            {id: 7, colWidth: "10%", colName: "성적표"},
            {id: 8, colWidth: "10%", colName: "캘린더"},
            {id: 9, colWidth: "15%", colName: "조회/수정/삭제"},
        ]

        this.getClassroomCategory();
        this.getStudentPaging();
    }

    getStudentPaging = () => {
        const pageVO = {
            page: this.curPage,
            size: this.itemRange,
            direction: 'DESC',
            sortBy: 'id'
        };

        AdminStudentService.getStudentList((this.selectClassroom == '전체 보기(학급)') ? null : this.selectClassroom, this.searchValue, pageVO).then((response) => {
            if (response !== null && response.status === 200) {
                this.totalPages = response.data.data.totalPages;
                this.setState({curPageStudentList: response.data.data.content});
            }
        }).catch((error) => {
            console.log(error);
            alert('SERVER ERROR');
        });
    }

    getClassroomCategory = () => {
        AdminClassroomService.getClassroomCategory()
            .then((response) => {
                if (response !== null && response.status === 200) {
                    let temp = this.classrooms;
                    let sortArray = response.data.data.sort(function (a, b) {
                        var nameA = a.toLowerCase(), nameB = b.toLowerCase();
                        if (nameA < nameB)
                            return -1;
                        if (nameA > nameB)
                            return 1;
                        return 0;
                    });

                    temp = temp.concat(sortArray);
                    this.classrooms = temp;
                }
            }).catch((error) => {
            console.log(error);
            alert('SERVER ERROR');
        });
    }

    // 옵션 세팅
    setOptionItemRange = () => {
        return (
            <div className="wrap-select">
                <span></span>
                <select id="itemRangeSelect" onChange={this.onClickOptionItemRange} value={this.itemRange}>
                    {this.optionItemRange.map(
                        (item) => (<option key={item.id} value={item.value}>{item.text}</option>)
                    )}
                </select>
            </div>
        );
    }

    onClickOptionItemRange = (e) => {
        this.itemRange = e.target.value;
        this.getStudentPaging();
    }

    setOptionClassroom = () => {
        return (
            <div className="wrap-select" onChange={this.onClickOptionClassroom}>
                <span></span>
                <select>
                    { this.classrooms.map((classroomName, i) => {
                        return <option key={i}>{classroomName}</option>
                    })}
                </select>
            </div>
        );
    }

    onClickOptionClassroom = (e) => {
        this.selectClassroom = e.target.value;
        this.getStudentPaging();
    }

    setFieldWidth = () => {
        return (
            <colgroup>
                {this.studentFieldInfo.map((info, i) => {
                    return <col key={i} width={info.colWidth}/>
                })}
            </colgroup>
        );
    }

    setFieldName = () => {
        return (
            <thead>
            <tr>
                {this.studentFieldInfo.map((info, i) => {
                    return <th key={i}>{info.colName}</th>
                })}
            </tr>
            </thead>
        );
    }

    setStudentInfos = () => {
        const {curPageStudentList} = this.state;
        return curPageStudentList.map(
            (student, i) => (
                <tr key={i}>
                    <td>{student.id}</td>
                    <td>{student.username}</td>
                    <td>{student.name}</td>
                    <td>{student.school}</td>
                    <td>{student.grade}</td>
                    <td>{student.emergencyContactNum}</td>
                    <td>{Moment(student.createdDate).format('YYYY-MM-DD')}</td>
                    <td>
                        <img onClick={() => this.showReportPopup(student)} src="/images/icon/icon_report_btn.png"
                             alt="report button" style={{width: '30px', cursor: 'pointer'}}/>
                        {/*<a className="btn-sm yellow" onClick={() => this.showReportPopup(student)}>보기</a>*/}
                    </td>
                    <td>
                        <img src="/images/icon/icon_calendar_btn.jpg" alt="calendar button" style={{width: '30px'}}/>
                        {/*<a className="btn-sm yellow">보기</a>*/}
                    </td>
                    <td>
                        <a className="btn-sm deepPink" onClick={() => this.showUpdatePopup(student)}>조회/수정/삭제</a>
                    </td>
                </tr>
            )
        )
    }

    showReportPopup = (student) => {
        this.setState({showReportPopup: true, student: student});
    }

    hideReportPopup = () => {
        this.setState({showReportPopup: false});
    }
    onUpdatePage = (page) => {
        this.curPage = page;
        this.getStudentPaging();
    }

    showUpdatePopup = (student) => {
        this.setState({isUpdateMode: true, registerPopupActive: true, selectStudent: student});
    }

    showRegisterPopup = () => {
        this.setState({registerPopupActive: true});
    }

    hideRegisterPopup = () => {
        this.setState({registerPopupActive: false, isUpdateMode: false});
    }

    submit = () => {
        this.hideRegisterPopup();
        this.getStudentPaging();
        // data refresh
    }

    // input 데이터 저장
    onInputValueChanged = (e) => {
        this.inputValue = e.target.value
    }

    // 학생 이름으로 검색
    onSearch = () => {
        if (this.inputValue == null || this.inputValue.length == 0) {
            this.searchValue = null;
        } else {
            this.searchValue = this.inputValue;
        }
        this.getStudentPaging();
    }

    render() {
        const {registerPopupActive, isUpdateMode, showReportPopup} = this.state;
        const percentage = 70;
        return (
            <div className="wrap-rCon">
                <div className="wrap-top">
                    <a className="baseBtn undefined blue" onClick={this.showRegisterPopup}><span>신규 학생등록</span></a>
                    <div className="box-rfix">
                        {this.setOptionItemRange()}
                        {this.setOptionClassroom()}
                        <div className="wrap-search">
                            <input className="ip-basic" type="text" placeholder="이름 검색"
                                   onChange={this.onInputValueChanged}/>
                            <a className="btn-sm yellow" onClick={() => this.onSearch()}>검색</a>
                        </div>
                    </div>
                </div>

                <div className="tb-scroll">
                    <table className="tb-basic">
                        {this.setFieldWidth()}
                        {this.setFieldName()}
                        <tbody>
                        {this.setStudentInfos()}
                        </tbody>
                    </table>
                </div>
                <PagingBtn currentPage={this.curPage} totalPages={this.totalPages} onUpdatePage={this.onUpdatePage}/>
                <PopupReportCard active={ showReportPopup } user={this.state.student} onClose={this.hideReportPopup}/>
                {/*<StyledProgressbar percentage={percentage} text={percentage} color='#f88'/>*/}
                <PopupRegisterForm active={registerPopupActive} isAdminMode={true} isUpdateMode={isUpdateMode}
                                   onConfirm={this.submit} onCancel={this.hideRegisterPopup}
                                   student={this.state.selectStudent}/>
            </div>
        );
    }
}

export default AdminManagementStudent;



// WEBPACK FOOTER //
// ./src/components/Pages/Teacher/AdminManagement/Student.js